import { atom } from 'recoil';

export interface PendingPopup {
  type: 'reward' | 'tutorial';
  slug: string;
  title?: string;
  description?: string;
  payout?: { sparks?: number; xp?: number };
}

export const pendingPopupsState = atom<PendingPopup[]>({
  key: 'pendingPopups',
  default: [],
});
